/// <reference path="../Page.ts" />
namespace HA.Core.HTML {
    //noinspection TsLint
    export class MenuPage extends Page {
        protected createSelf() {
            super.createSelf();
            this.addClass("pa-m");
        }
    }
}
